import { Model } from "./Model";
import { Player } from "./Index";

export interface Goal extends Model {
	fixtureId: number;
	playerId: number;
	player: Player
}

export class Goal implements Goal {

	constructor(data?: Partial<Goal>) {
		if (data) {
			for (const key of Object.keys(data)) {
				(this as any)[key] = (data as any)[key];
			}
		}
	}
}